module.exports = __webpack_public_path__ + "img/0.4a51dea1.jpg";